@if (vm$ | async; as vm) {
  <mat-card [class.folded]="folded" class="foldable mat-elevation-z0 p-2" appearance="raised">
    <button mat-icon-button class="btn-fold" (click)="folded = !folded">
      <mat-icon>{{ folded ? "unfold_more" : "unfold_less" }}</mat-icon>
    </button>
    <div class="header">
      <div class="book-img-container">
        <app-safe-image [src]="vm.coverSrc" imgClass="mat-elevation-z1" [alt]="vm.title" [fluid]="true" />
      </div>
      <div class="book-txt-container">
        <h3 class="book-title">{{ vm.title }}</h3>
        @if (!folded) {
          <div class="book-description" animate.enter="v-expand-in" animate.leave="v-expand-out">
            <div>
              <div>
                @for (date of vm.period; track date; let first = $first) {
                  {{ !first ? " - " : "" }}
                  {{ date | date: "d. MMMM y" }}
                }
              </div>
              @if (vm.pageCount) {
                <div>
                  {{ "SEARCH_RESULT.PAGES" | translate: { pages: vm.pageCount } }}
                </div>
              }
            </div>
          </div>
        }
        @if (!folded) {
          <div class="book-actions" animate.enter="v-expand-in" animate.leave="v-expand-out">
            <div>
              @if (vm.downloadLink) {
                <a matButton="filled" color="secondary" [href]="vm.downloadLink" target="_blank" download>
                  <mat-icon>cloud_download</mat-icon>
                  {{ "DOWNLOAD_BTN" | translate }}
                </a>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </mat-card>
}
